export const _SERVER_DOMAIN = "https://management.spacium.ae";
// export const _SERVER_DOMAIN = "http://localhost:8000";
